import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import numeral from "numeral";
import React  from "react";
import NumberFormat from "react-number-format";
import AccountAutocomplete from "../../../general/autocompleteSelector/accountAutocomplete";

const ContextualPaymentRow = ({isLoading, indexRow, isError, isTrashIcon,
  changeContextualPayments, removeItems, showPopover, setShowPopover, total, conto}) => {

  return (
    <div style={{display:"flex", marginTop: "16px"}}>
      <div style={{flex: "0 0 auto"}}>
        <div style={{marginBottom: "4px"}}>Importo *</div>
        <NumberFormat
          displayType={"input"}
          thousandSeparator={"."}
          decimalSeparator={","}
          className={`ant-input accounting-accounts-search vapor ${isError ? "error" : ""}`}
          placeholder="0,00 €"
          suffix={" €"}
          value={
            total !== 0
              ? numeral(Math.abs(total)).format("0,0.00")
              : ""
          }
          onValueChange={values => {
            changeContextualPayments(
              indexRow, "total", values.floatValue
            );
          }}
        />
        {isError && <span>L'importo totale supera l'importo fattura </span>}
      </div>
      <div style={{
        flexGrow: 0,
        flexShrink: 1,
        flexBasis: "calc(33% - 24px)", marginLeft: "40px", whiteSpace: "nowrap",
        minWidth: "120px", width: `${conto ? conto.length * 9 : 100}px` }}>
        <div style={{marginBottom: "4px"}}>Conto contabile *</div>
        <AccountAutocomplete
          popoverPlacement="bottom"
          isAccountingAccounts={true}
          isPrecogPage={true}
          rowId={indexRow}
          vapor={true}
          onChange={(e) => {
            // prendo solo il codice
            changeContextualPayments(
              indexRow, "conto", e.split("-")[0].trim()
            );
          }}
          popoverVisible={showPopover?.id === indexRow}
          setPopoverVisible={ (val) => setShowPopover(val)}
          initialValue={conto}
        />
      </div>
      <div style={{flex: "0 0 auto",
        alignItems: "flex-end",
        justifyContent: "flex-end",
        display: "flex",
        marginLeft: "20px",
        marginBottom: "14px"}}
      >
        <div style={{marginBottom: "4px"}}></div>
        {isLoading ?
          <FontAwesomeIcon icon={["far", "spinner"]} style={{
            color: "#0090d1",
            fontSize: "14px",
            cursor: "pointer",
            marginBottom: isError ? "20px" : 0
          }} spin /> :
          isTrashIcon &&
          <FontAwesomeIcon
            tabIndex={indexRow === 0 ? "-1" : "0"} role="button" aria-pressed="false"
            icon={["far", "trash-alt"]}
            onClick={e => removeItems(indexRow)}
            onKeyDown={e => indexRow !== 0 && e.keyCode === 13 ? removeItems(indexRow) : null}
            style={{
              color: "#d82829",
              fontSize: "14px",
              cursor: "pointer",
              marginBottom: isError ? "20px" : 0
            }}
          />}
      </div>
    </div>
  );
};

export default ContextualPaymentRow;